export default "__VITE_ASSET__CHPrzoNb__"